// The admin's live arithmetic for the invoice editor. Must give exactly the same answers as calc() in src/invoices.js (the server
// recomputes everything before saving; a test checks the two agree).
const cents = (n) => {
  const v = Number(n);
  if (!Number.isFinite(v)) return 0;
  return Math.round(v * 100 + (v < 0 ? -1e-8 : 1e-8));
};
const units = (c) => c / 100;
const clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, n));

export function calc(inv = {}) {
  const lines = (inv.items || []).map(i => {
    const qty = clamp(Number(i.quantity) || 0, 0, 1e6);
    return cents(Math.round(qty * cents(i.unitPrice)) / 100);
  });
  const subtotal = lines.reduce((a, b) => a + b, 0);
  let discount = 0;
  const dv = Number(inv.discountValue) || 0;
  if (inv.discountType === 'percent') discount = Math.round(subtotal * clamp(dv, 0, 100) / 100);
  else if (inv.discountType === 'amount') discount = Math.min(subtotal, Math.max(0, cents(dv)));
  const taxable = subtotal - discount;
  const rate = clamp(Number(inv.taxRate) || 0, 0, 100);
  const tax = Math.round(taxable * rate / 100);
  return { lines: lines.map(units), subtotal: units(subtotal), discount: units(discount), taxable: units(taxable), tax: units(tax), total: units(taxable + tax) };
}

export function balanceOf(total, payments = []) {
  const paid = (payments || []).reduce((a, p) => a + cents(p.amount), 0);
  return { paid: units(paid), balance: units(Math.max(0, cents(total) - paid)) };
}

export const todayLocal = () => new Date().toLocaleDateString('en-CA');
export function addDays(date, days) {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + Math.round(days));
  return d.toISOString().slice(0, 10);
}

/** draft | issued | partial | overdue | paid | void, as in the server. */
export function displayStatus(inv, today = todayLocal()) {
  if (inv.status === 'draft' || inv.status === 'void' || inv.status === 'paid') return inv.status;
  const { paid, balance } = balanceOf(inv.total, inv.payments);
  if (balance <= 0 && paid > 0) return 'paid';
  if (inv.dueDate && inv.dueDate < today) return 'overdue';
  return paid > 0 ? 'partial' : 'issued';
}

/** "R12 345.60" (a plain space between thousands, which every font has). */
export const fmtMoney = (n, currency = 'R') => `${currency}${Number(n || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`;
